/* Núvo — Free Shipping Pass promo: add-to-cart on the PDP.
   The promo CTA is a real form (progressive enhancement) — without JS it posts
   to /cart and works. With JS we intercept, add via /cart/add.js, and the cart
   drawer opens via nuvo-cart-open.js (which observes /cart/add.js POSTs). */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function bind(form) {
    if (form.__nuvoPassInit) return;
    form.__nuvoPassInit = true;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idEl = form.querySelector('input[name="id"]');
      var btn = form.querySelector('button');
      var label = form.querySelector('[data-pass-add-label]');
      if (!idEl || !btn || btn.disabled) return;

      var orig = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(idEl.value), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (label) label.textContent = 'Added ✓';
          setTimeout(function () { if (label) label.textContent = orig; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          if (label) label.textContent = 'Try again';
          setTimeout(function () { if (label) label.textContent = orig; btn.disabled = false; }, 1500);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pass-add]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
